<div class="page-header">
  <div>
    <h1>{{ t('loginFormLink') }}</h1>
    <p>{{ t('LoginIncludeInstructions') }}</p>
  </div>
  <button class="primary-button" type="button" (click)="save()"><wa-icon name="floppy"></wa-icon>{{ t('HubSaveLabels') }}</button>
</div>

@if (error) {
  <p class="message error">{{ error }}</p>
}
@if (success) {
  <p class="message success">{{ success }}</p>
}
@if (loading) {
  <p>{{ t('HubLoginFormLoading') }}</p>
}

@if (!loading && data) {
  <div class="login-form-layout">
    <section class="card editor-card">
      <div class="tab-list" role="tablist">
        @for (language of data.languages; track language) {
          <button type="button" class="tab-button" role="tab" [attr.aria-selected]="language === activeLanguage" [class.active]="language === activeLanguage" (click)="activeLanguage = language">{{ language }}</button>
        }
      </div>
      <select class="mobile-tab-select" [(ngModel)]="activeLanguage" aria-label="Login form language">
        @for (language of data.languages; track language) {
          <option [value]="language">{{ language }}</option>
        }
      </select>
      <div class="form-grid">
        @for (label of data.labels; track label) {
          <label>
            {{ label }}
            <input [name]="label + '-' + activeLanguage" [(ngModel)]="data.translations[label][activeLanguage]" [placeholder]="label">
          </label>
        }
      </div>
      <h2>{{ t('InsertIntoWebpage') }}</h2>
      <div class="embed-code-row">
        <input class="embed-code" readonly [value]="data.embedCode">
        <button class="secondary-button" type="button" (click)="copyEmbedCode()">{{ t('HubCopyEmbedCode') }}</button>
      </div>
    </section>
    <section class="card preview-card">
      <h2>{{ t('LoginIncludePreviewHeader') }}</h2>
      <iframe [src]="previewUrl(activeLanguage)" title="Login form preview"></iframe>
    </section>
  </div>
}
